export type NavLink = {
  label: string;
  href: string;
};

export const navLinks: NavLink[] = [
  { label: "Jak to funguje", href: "#jak-to-funguje" },
  { label: "Výhody", href: "#vyhody" },
  { label: "Kontakt", href: "#kontakt" },
];

export const navCta = {
  label: "Chci být vidět",
  href: "#kontakt",
} as const;
